/**
 * @shelf-version: 1.0.0
 */

import API from './api';

export default API;
